import React, { useState } from "react";
import { FaRegTrashAlt } from "react-icons/fa";
import { AiOutlinePlusSquare } from "react-icons/ai";
import { PiPencilSimpleLine } from "react-icons/pi";
import CustomSvg from "../../../../../components/common/custom-svg/custom-svg";
import ConfirmDeleteIcon from "../../../../../assets/icons-v2/confirm_delete.png";

const FeedList = ({ feeds, onAdd, onEdit, onDelete, isEmpty }) => {
    const [showConfirm, setShowConfirm] = useState(false);
    const [selectedFeed, setSelectedFeed] = useState(null);

    const handleDeleteClick = (feed) => {
        setSelectedFeed(feed);
        setShowConfirm(true);
    };

    const handleConfirmDelete = () => {
        if (selectedFeed) {
            onDelete?.(selectedFeed);
        }
        setShowConfirm(false);
        setSelectedFeed(null);
    };

    const handleCancel = () => {
        setShowConfirm(false);
        setSelectedFeed(null);
    };

    return (
        <div className="tw-flex tw-flex-col tw-h-full tw-min-h-[250px] tw-max-h-[80vh]">
            <div className="tw-flex-1 tw-overflow-y-auto tw-p-4 tw-space-y-2">
                {isEmpty ? (
                    <div className="tw-text-center tw-text-gray-400 tw-my-8">No custom feeds yet.</div>
                ) : (
                    feeds.map((feed) => (
                        <div
                            key={feed.id}
                            className="tw-bg-white tw-rounded-xl tw-shadow tw-p-4 tw-flex tw-items-center tw-justify-between"
                        >
                            <span className="tw-font-semibold tw-text-gray-800">{feed.name}</span>
                            <div className="tw-flex tw-gap-3">
                                <PiPencilSimpleLine
                                    className="tw-text-[#5A8CF3] tw-cursor-pointer tw-text-xl"
                                    onClick={() => onEdit?.(feed)}
                                />
                                <FaRegTrashAlt
                                    className="tw-text-[#EA4949] tw-cursor-pointer tw-text-xl"
                                    onClick={() => handleDeleteClick(feed)}
                                />
                            </div>
                        </div>
                    ))
                )}
            </div>
            <div className="tw-p-4 tw-bg-white tw-border-t tw-border-gray-100 tw-sticky tw-bottom-0">
                <button
                    className="tw-bg-white tw-rounded-xl tw-shadow tw-p-4 tw-flex tw-items-center tw-justify-between tw-w-full hover:tw-bg-gray-50"
                    onClick={onAdd}
                >
                    <span className="tw-text-gray-700 tw-font-semibold">Add a New List</span>
                    <AiOutlinePlusSquare className="tw-text-gray-700 tw-text-2xl" />
                </button>
            </div>
            {/* Confirmation Modal */}
            {showConfirm && (
                <div className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-30 tw-z-50">
                    <div className="tw-fixed tw-bottom-0 tw-left-0 tw-w-full tw-bg-white tw-rounded-t-2xl tw-shadow-lg tw-px-8 tw-py-8 tw-flex tw-flex-col tw-items-center tw-max-w-md tw-mx-auto tw-min-h-[250px] tw-max-h-[80vh]">
                        <div className="tw-mb-4 tw-flex tw-flex-col tw-items-center">
                            <span className="tw-text-5xl tw-mb-2">
                                <CustomSvg src={ConfirmDeleteIcon} size={{ width: 59, height: 59 }} />
                            </span>
                            <div className="tw-text-xl tw-font-bold tw-mb-2 tw-opacity-70">Delete</div>
                            <div className="tw-text-center tw-mb-1">
                                Are you sure you want to delete this feed?
                            </div>
                            <div className="tw-font-bold tw-text-lg tw-mb-2">{selectedFeed?.name}</div>
                        </div>
                        <div className="tw-flex tw-gap-4 tw-mt-2 tw-w-full">
                            <button
                                className="tw-flex-1 tw-bg-gray-100 tw-text-gray-700 tw-py-2 tw-rounded-lg tw-font-semibold hover:tw-bg-gray-200"
                                onClick={handleCancel}
                            >
                                No, Keep it
                            </button>
                            <button
                                className="tw-flex-1 tw-bg-[#EA4949] tw-text-white tw-py-2 tw-rounded-lg tw-font-semibold hover:tw-bg-red-700"
                                onClick={handleConfirmDelete}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FeedList;
